module.exports = __webpack_public_path__ + "img/course_008.6a38717.png";